const actionTypes = {
    GET_REF_DATA_PURGE_SETUPS: 'GET_REF_DATA_PURGE_SETUPS',
    GET_REF_DATA_PURGE_CONFIGS: 'GET_REF_DATA_PURGE_CONFIGS',
};

export default actionTypes;